import { useHeaderContext } from "@/contexts/HeaderContext";

export const useHeaderHeight = (): number => {
  const { size } = useHeaderContext();

  return size.height;
};
